"use client";

const STEPS = [
  {
    kicker: "SHOP MENU",
    title: "Browse our legal Calgary weed delivery menu online",
  },
  {
    kicker: "ADD TO CART",
    title: "Choose flower, vapes, edibles, and more, then add to cart",
  },
  {
    kicker: "CHECKOUT SECURELY",
    title: "Complete your order online using your credit card",
  },
  {
    kicker: "WE DELIVER",
    title: "Same-day delivery in 45 minutes with SMS tracking",
  },
] as const;

export default function HowCannabisDeliveryStepsSection() {
  return (
    <section className="w-full max-w-none" aria-labelledby="how-steps-heading">
      <div className="w-full">
        <h2
          id="how-steps-heading"
          className="text-h3-mobile sm:text-h3-desktop font-bold text-text-primary"
        >
          How our cannabis delivery works
        </h2>
        <p className="mt-3 max-w-3xl text-body-md text-text-secondary">
          Dank&apos;s mail order marijuana Canada service makes it easy to shop without driving to retail locations.
          High-quality cannabis products, trained fulfillment specialists, and fast online weed delivery across Alberta
          with SMS tracking.
        </p>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <div
              key={step.kicker}
              className="relative overflow-hidden rounded-2xl border border-neutral-10 bg-constant-white p-5 shadow-sm"
            >
              <span
                className="pointer-events-none absolute -right-2 -top-4 text-[72px] font-bold leading-none text-neutral-10 select-none"
                aria-hidden
              >
                {i + 1}
              </span>
              <span className="relative inline-block rounded-lg border border-blue-80 px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-blue-100">
                {step.kicker}
              </span>
              <p className="relative mt-4 text-body-md font-medium leading-snug text-text-primary">{step.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
